module.exports = __webpack_public_path__ + "img/bedrijventerrein.b02a1ab6.png";